import { Component, OnInit, Input } from '@angular/core';
import { DealsWizardModel } from '../../../_models/_index';
import { DealStepEnum } from '../../../_enums/_index';
import { UserService } from '../../../services/_index';

@Component({
    selector: 'deal-welcome',

    templateUrl: 'deal-welcome.component.html'

})

export class DealWelcomeComponent implements OnInit {
    @Input()
    dealStep: DealStepEnum;

    constructor(private userService: UserService) {

    }

    ngOnInit() {
    }

    isCustomer() {
        return this.userService.isCustomer();
    }

    isRepresentative() {
        return this.userService.isRepresentative();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-welcome/deal-welcome.component.ts